import { usePageMeta } from "../hooks/usePageMeta";
import { PageHero } from "../components/PageHero";
import { CONTACT } from "../data/site";

const sections = [
  {
    title: "1. Cosa sono i cookie",
    body: "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. Consentono al sito di funzionare correttamente e di migliorare l'esperienza di navigazione.",
  },
  {
    title: "2. Cookie tecnici",
    body: "Questo sito utilizza cookie tecnici, necessari al corretto funzionamento delle pagine e dei servizi (ad esempio gestione della sessione e preferenze di navigazione). Questi cookie non richiedono il consenso dell'utente.",
  },
  {
    title: "3. Strumenti di analisi",
    body: "Il sito può utilizzare strumenti di analisi statistica con raccolta di dati in forma aggregata e anonima, al fine di migliorare contenuti e navigazione. Tali strumenti non vengono utilizzati per profilazione pubblicitaria.",
  },
  {
    title: "4. Cookie di terze parti",
    body: "Il sito non installa cookie di profilazione di terze parti. Eventuali contenuti incorporati da servizi esterni potrebbero rilasciare propri cookie secondo le rispettive informative.",
  },
  {
    title: "5. Gestione delle preferenze",
    body: "Puoi gestire o eliminare i cookie direttamente dalle impostazioni del tuo browser. La disattivazione dei cookie tecnici potrebbe compromettere il corretto funzionamento di alcune parti del sito.",
  },
  {
    title: "6. Contatti",
    body: `Per qualsiasi domanda relativa alla presente cookie policy puoi scrivere a ${CONTACT.email}. Ultimo aggiornamento: luglio 2026.`,
  },
];

export default function Cookie() {
  usePageMeta(
    "Cookie Policy | Costruzioni Ciosko",
    "Cookie policy del sito di Costruzioni Ciosko: quali cookie utilizziamo e come gestire le tue preferenze."
  );
  return (
    <>
      <PageHero overline="Documenti" lines={["Cookie Policy"]} description="Informazioni sull'utilizzo dei cookie su questo sito." />
      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-5 lg:px-10 space-y-10">
          {sections.map((s) => (
            <article key={s.title}>
              <h2 className="font-display font-bold text-lg sm:text-xl text-white tracking-tight">{s.title}</h2>
              <p className="text-cement text-sm sm:text-[15px] leading-relaxed mt-3">{s.body}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
